import React, { useState } from 'react';
import { Box, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export const AuthTestPage: React.FC = () => {
  const { user, token, login, logout, loading, isAuthenticated } = useAuth();
  const [testResult, setTestResult] = useState<string>('');
  const [testLoading, setTestLoading] = useState(false);

  const testLogin = async () => {
    setTestLoading(true);
    setTestResult('');
    
    try {
      await login('testuser@example.com', 'TestPassword123!');
      setTestResult('✅ Login successful!');
    } catch (error: any) {
      setTestResult(`❌ Login failed: ${error.message}`);
    } finally {
      setTestLoading(false);
    }
  };

  const testLogout = () => {
    logout();
    setTestResult('✅ Logout successful!');
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Authentication Test Page
      </Typography>
      
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6">Current Status:</Typography>
        <Typography>Authenticated: {isAuthenticated ? '✅ Yes' : '❌ No'}</Typography>
        <Typography>User: {user ? `${user.first_name} ${user.last_name}` : 'None'}</Typography>
        <Typography>Email: {user?.email || 'None'}</Typography>
        <Typography>Role: {user?.role || 'None'}</Typography>
        <Typography>Token: {token ? `${token.substring(0, 20)}...` : 'None'}</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
        <Button 
          variant="contained" 
          onClick={testLogin}
          disabled={testLoading || isAuthenticated}
        >
          Test Login
        </Button>
        
        <Button 
          variant="outlined" 
          onClick={testLogout}
          disabled={testLoading || !isAuthenticated}
        >
          Test Logout
        </Button>
      </Box>

      {testLoading && <CircularProgress />}
      
      {testResult && (
        <Alert severity={testResult.includes('✅') ? 'success' : 'error'}>
          {testResult}
        </Alert>
      )}
    </Box>
  );
};
